module.exports = __webpack_public_path__ + "static/case-slide-4-8752027fb8569ca17733a84ebdf7974b.jpg";